/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthorizationStatus,
  BigRocksResponse,
} from '../models';
import {
    AuthorizationStatusFromJSON,
    AuthorizationStatusToJSON,
    BigRocksResponseFromJSON,
    BigRocksResponseToJSON,
} from '../models';

export interface GetBigRocksRequest {
    authorization?: string;
    onBehalfOf?: string;
}

export interface GetBigRocksByGroupIdRequest {
    id: number;
    authorization?: string;
    onBehalfOf?: string;
}

/**
 * 
 */
export class BigRocksApi extends runtime.BaseAPI {

    /**
     * Gets big rocks
     */
    async getBigRocksRaw(requestParameters: GetBigRocksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BigRocksResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/big-rocks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BigRocksResponseFromJSON(jsonValue));
    }

    /**
     * Gets big rocks
     */
    async getBigRocks(requestParameters: GetBigRocksRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BigRocksResponse> {
        const response = await this.getBigRocksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets big rocks for given group
     */
    async getBigRocksByGroupIdRaw(requestParameters: GetBigRocksByGroupIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BigRocksResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getBigRocksByGroupId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/big-rocks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BigRocksResponseFromJSON(jsonValue));
    }

    /**
     * Gets big rocks for given group
     */
    async getBigRocksByGroupId(requestParameters: GetBigRocksByGroupIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BigRocksResponse> {
        const response = await this.getBigRocksByGroupIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
